import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';

import { store } from './store/store';
import ThemeContextProvider from './context/ThemeContext';
import { LoggedInUserContextProvider } from './context/LoggedInUserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename="/">
        <ThemeContextProvider>
          <LoggedInUserContextProvider>
            <App />
          </LoggedInUserContextProvider>
        </ThemeContextProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
